import { Flex, Text } from '@chakra-ui/react'
import { ModalLayoutFinalizado } from './components/ModalLayoutFinalizado'

export function Contadores({ data, controleLayout }) {
  const informacaoSemana = controleLayout?.map((item) => {
    return {
      nome: item.nome,
      quantidade: item.quantidade_semana,
      quantidade_dia: item.quantidade_no_dia,
    }
  })

  const informacaoDia = controleLayout?.map((item) => {
    return {
      nome: item.nome,
      quantidade: item.quantidade_no_dia,
    }
  })

  const countSemana = informacaoSemana?.reduce((acc, item) => {
    return acc + parseInt(item.quantidade)
  }, 0)

  const countDia = informacaoDia?.reduce((acc, item) => {
    return acc + parseInt(item.quantidade)
  }, 0)

  return (
    <>
      <Flex marginLeft="1rem" marginBottom="1rem" gap={2}>
        <>
          <ModalLayoutFinalizado
            buttonName={`Layouts finalizados no dia: ${countDia ?? 0}`}
            title="Layouts finalizados no dia"
            data={informacaoDia}
          />
          <ModalLayoutFinalizado
            buttonName={`Layouts finalizados na semana: ${countSemana ?? 0}`}
            title="Layouts finalizados na semana"
            data={informacaoSemana}
          />
        </>
      </Flex>
    </>
  )
}
